<!--
 * @Description: 
 * @Version: 
 * @Autor: houcf
 * @Date: 2023-05-06 14:07:06
 * @LastEditTime: 2023-05-06 14:07:44
-->
<template>
  <div>
    <trainList />
  </div>

</template>
<script>
import trainList from '@/components/public/trainList';
export default {
  components: {
    trainList
  },
  data() {
    return {};
  },
  methods: {}
};
</script>